import { render, staticRenderFns } from "./DataObjectActivitiesModal.vue?vue&type=template&id=ce5a4446&"
import script from "./DataObjectActivitiesModal.vue?vue&type=script&lang=js&"
export * from "./DataObjectActivitiesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports